(function () {
  function sections(root, selector) {
    var matches = root.matches && root.matches(selector) ? [root] : [];
    return matches.concat(Array.from(root.querySelectorAll(selector)));
  }
  function init(root) {
    sections(root, '.cf-product-header-section').forEach(function (section) {
      var toggle = section.querySelector('.cf-menu-toggle');
      var nav = section.querySelector('.cf-navlinks');
      if (!toggle || !nav || toggle.dataset.cfReady) return;
      toggle.dataset.cfReady = '1';
      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('open');
        toggle.setAttribute('aria-expanded', String(open));
      });
      nav.addEventListener('click', function (event) {
        if (event.target.closest('a')) {
          nav.classList.remove('open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
    sections(root, '.cf-product-main-section').forEach(function (section) {
      var main = section.querySelector('.cf-gallery-main img');
      section.querySelectorAll('.cf-gallery-thumb').forEach(function (thumb) {
        if (thumb.dataset.cfReady) return;
        thumb.dataset.cfReady = '1';
        thumb.addEventListener('click', function () {
          if (!main) return;
          section.querySelectorAll('.cf-gallery-thumb').forEach(function (other) {
            other.setAttribute('aria-pressed', 'false');
          });
          thumb.setAttribute('aria-pressed', 'true');
          main.src = thumb.dataset.src;
          main.alt = thumb.dataset.alt || main.alt;
        });
      });
      var select = section.querySelector('.cf-variant-select');
      if (!select || select.dataset.cfReady) return;
      select.dataset.cfReady = '1';
      function update() {
        var choice = select.selectedOptions[0];
        if (!choice) return;
        var available = choice.dataset.available === 'true';
        var price = section.querySelector('.cf-price');
        var availability = section.querySelector('.cf-availability');
        var add = section.querySelector('.cf-add-button');
        var payment = section.querySelector('.cf-buy-now');
        if (price) price.textContent = choice.dataset.price;
        if (availability) availability.textContent = available ? availability.dataset.availableText : availability.dataset.unavailableText;
        if (add) add.disabled = !available;
        if (payment) payment.hidden = !available;
      }
      select.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
